"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _plantNursery = require("@/services/plant-nursery.service");
var _LotsList = _interopRequireDefault(require("@/flow/plantNursery/components/LotsList.vue"));
var _LotInventorySelector = _interopRequireDefault(require("@/flow/plantNursery/components/LotInventorySelector.vue"));
var _AutocompleteSelect = _interopRequireDefault(require("@/ui/components/inputs/AutocompleteSelect.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'PartialGraftLotPage',
  components: {
    Page: _Page.default,
    LotsList: _LotsList.default,
    LotInventorySelector: _LotInventorySelector.default,
    AutocompleteSelect: _AutocompleteSelect.default
  },
  data: function data() {
    return {
      selectedLot: null,
      lots: [],
      isLoadingLots: false,
      lotListSearch: '',
      form: this.createDefaultForm(),
      isSubmitting: false,
      varieties: [],
      receiverLot: null,
      receiverLotItems: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsPlantsNursery',
    farm: 'GET_FARM'
  })), {}, {
    scionVarieties: function scionVarieties() {
      var items = Array.isArray(this.varieties) ? this.varieties : [];
      return items.filter(function (variety) {
        return (variety === null || variety === void 0 ? void 0 : variety.type) === 'scion';
      });
    },
    senderTotal: function senderTotal() {
      if (!Array.isArray(this.form.senderInventories)) return 0;
      return this.form.senderInventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    receiverTotal: function receiverTotal() {
      if (!Array.isArray(this.form.receiverInventories)) return 0;
      return this.form.receiverInventories.reduce(function (sum, inv) {
        return sum + (Number(inv.quantity) || 0);
      }, 0);
    },
    quantityMismatch: function quantityMismatch() {
      return this.senderTotal !== this.receiverTotal;
    }
  }),
  watch: {
    selectedLot: function selectedLot(newLot) {
      if (newLot) {
        this.resetForm();
      }
    },
    'form.scionId': function formScionId(newScionId, oldScionId) {
      if (newScionId !== oldScionId) {
        this.form.receiverLotId = null;
        this.receiverLot = null;
        this.receiverLotItems = [];
        this.form.receiverInventories = [];
        if (newScionId) {
          this.fetchReceiverLots({});
        }
      }
    }
  },
  mounted: function mounted() {
    this.loadLots();
    this.loadVarieties();
  },
  methods: {
    handleLotsSearch: function handleLotsSearch(searchQuery) {
      this.lotListSearch = searchQuery;
      this.loadLots();
    },
    loadLots: function () {
      var _loadLots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm, filters, _yield$plantNurserySe, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.isLoadingLots = true;
              _context.p = 1;
              filters = {
                page: 1,
                limit: 200,
                type: 'graft',
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id,
                plantingOrRegraft: true
              };
              if (this.lotListSearch) {
                filters.code = this.lotListSearch;
              }
              _context.n = 2;
              return _plantNursery.plantNurseryService.fetchLots(filters);
            case 2:
              _yield$plantNurserySe = _context.v;
              response = _yield$plantNurserySe.data;
              this.lots = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.lots = [];
            case 4:
              _context.p = 4;
              this.isLoadingLots = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadLots() {
        return _loadLots.apply(this, arguments);
      }
      return loadLots;
    }(),
    loadVarieties: function () {
      var _loadVarieties = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$farm2, _yield$plantNurserySe2, response, items, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _plantNursery.plantNurseryService.fetchVarieties({
                page: 1,
                limit: 200,
                farmId: (_this$farm2 = this.farm) === null || _this$farm2 === void 0 ? void 0 : _this$farm2.id
              });
            case 1:
              _yield$plantNurserySe2 = _context2.v;
              response = _yield$plantNurserySe2.data;
              items = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              this.varieties = items;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.varieties = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadVarieties() {
        return _loadVarieties.apply(this, arguments);
      }
      return loadVarieties;
    }(),
    createDefaultForm: function createDefaultForm() {
      return {
        scionId: null,
        graftAt: new Date(),
        senderInventories: [],
        receiverLotId: null,
        receiverInventories: []
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
      this.receiverLot = null;
      this.receiverLotItems = [];
    },
    clearSelection: function clearSelection() {
      this.selectedLot = null;
      this.resetForm();
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$router.push({
        name: 'plant-nursery-lots'
      });
    },
    addLotDisplayFields: function addLotDisplayFields(lots) {
      if (!Array.isArray(lots)) return [];
      return lots.map(function (lot) {
        var _lot$code, _lot$id, _lot$rootstock, _lot$scion;
        return _objectSpread(_objectSpread({}, lot), {}, {
          title: (_lot$code = lot === null || lot === void 0 ? void 0 : lot.code) !== null && _lot$code !== void 0 ? _lot$code : "Lote #".concat((_lot$id = lot === null || lot === void 0 ? void 0 : lot.id) !== null && _lot$id !== void 0 ? _lot$id : ''),
          description: "".concat(lot === null || lot === void 0 ? void 0 : (_lot$rootstock = lot.rootstock) === null || _lot$rootstock === void 0 ? void 0 : _lot$rootstock.name, " ").concat(lot === null || lot === void 0 ? void 0 : (_lot$scion = lot.scion) === null || _lot$scion === void 0 ? void 0 : _lot$scion.name)
        });
      });
    },
    fetchReceiverLots: function () {
      var _fetchReceiverLots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
        var search, _this$farm3, _this$selectedLot, _this$selectedLot$roo, requestParams, _yield$plantNurserySe3, response, items, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.form.scionId) {
                _context3.n = 1;
                break;
              }
              this.receiverLotItems = [];
              return _context3.a(2, {
                data: [],
                lastPage: 1
              });
            case 1:
              search = (params === null || params === void 0 ? void 0 : params.search) || '';
              _context3.p = 2;
              requestParams = {
                page: 1,
                limit: 50,
                type: 'graft',
                stage: 'grafting',
                farmId: (_this$farm3 = this.farm) === null || _this$farm3 === void 0 ? void 0 : _this$farm3.id,
                scionId: this.form.scionId,
                rootstockId: (_this$selectedLot = this.selectedLot) === null || _this$selectedLot === void 0 ? void 0 : (_this$selectedLot$roo = _this$selectedLot.rootstock) === null || _this$selectedLot$roo === void 0 ? void 0 : _this$selectedLot$roo.id
              };
              if (search) {
                requestParams.code = search;
              }
              _context3.n = 3;
              return _plantNursery.plantNurseryService.fetchLots(requestParams);
            case 3:
              _yield$plantNurserySe3 = _context3.v;
              response = _yield$plantNurserySe3.data;
              items = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              this.receiverLotItems = this.addLotDisplayFields(items);
              return _context3.a(2, {
                data: this.receiverLotItems,
                lastPage: 1
              });
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              this.receiverLotItems = [];
              return _context3.a(2, {
                data: [],
                lastPage: 1
              });
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function fetchReceiverLots(_x) {
        return _fetchReceiverLots.apply(this, arguments);
      }
      return fetchReceiverLots;
    }(),
    onReceiverLotChange: function onReceiverLotChange(lotId) {
      if (!lotId) {
        this.receiverLot = null;
        this.form.receiverInventories = [];
        return;
      }
      var lot = this.receiverLotItems.find(function (l) {
        return l.id === lotId;
      });
      if (lot) {
        this.receiverLot = lot;
        this.form.receiverInventories = [];
      }
    },
    validateForm: function validateForm() {
      var _this$form$senderInve, _this$form$receiverIn;
      if (!this.form.scionId) {
        this.$buefy.toast.open({
          message: 'Selecione a copa para enxertia.',
          type: 'is-danger'
        });
        return false;
      }
      if (!((_this$form$senderInve = this.form.senderInventories) !== null && _this$form$senderInve !== void 0 && _this$form$senderInve.length)) {
        this.$buefy.toast.open({
          message: 'Adicione pelo menos um local de origem.',
          type: 'is-danger'
        });
        return false;
      }
      if (!this.form.receiverLotId) {
        this.$buefy.toast.open({
          message: 'Selecione o lote de destino.',
          type: 'is-danger'
        });
        return false;
      }
      if (!((_this$form$receiverIn = this.form.receiverInventories) !== null && _this$form$receiverIn !== void 0 && _this$form$receiverIn.length)) {
        this.$buefy.toast.open({
          message: 'Adicione pelo menos um local de destino.',
          type: 'is-danger'
        });
        return false;
      }
      if (this.quantityMismatch) {
        this.$buefy.toast.open({
          message: "Quantidade de origem (".concat(this.senderTotal, ") deve ser igual \xE0 quantidade de destino (").concat(this.receiverTotal, ")."),
          type: 'is-danger'
        });
        return false;
      }
      return true;
    },
    buildPayload: function buildPayload() {
      var mergedAt = this.form.graftAt ? new Date(this.form.graftAt).toISOString() : new Date().toISOString();
      return {
        scionId: this.form.scionId,
        mergedAt: mergedAt,
        senderInventories: this.form.senderInventories,
        receiverInventories: this.form.receiverInventories
      };
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var payload, _error$response, _error$response$data, message, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.validateForm()) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              payload = this.buildPayload();
              this.isSubmitting = true;
              _context4.p = 2;
              _context4.n = 3;
              return _plantNursery.plantNurseryService.partialGraftLot(this.selectedLot.id, payload);
            case 3:
              this.$buefy.toast.open({
                message: 'Enxertia parcial realizada com sucesso.',
                type: 'is-success'
              });
              this.$router.push({
                name: 'plant-nursery-lots'
              });
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              message = (_t4 === null || _t4 === void 0 ? void 0 : (_error$response = _t4.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || 'Não foi possível realizar a enxertia parcial.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 5:
              _context4.p = 5;
              this.isSubmitting = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
  }
};